import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { IDatasource } from 'ngx-ui-scroll';

@Component({
  selector: 'app-list-hiking',
  templateUrl: './list-hiking.component.html',
  styleUrls: ['./list-hiking.component.scss'],
})
export class ListHikingComponent {
  public hikingList = input.required<any[]>();
  
  private _router = inject(Router);
  
  datasource: IDatasource = {
    get: (index, count, success) => {
      const data = [];
      for (let i = index; i <= index + count - 1; i++) {
        if (this.hikingList()?.length > i)
          data.push({type: 'item', data: this.hikingList()[i]});
      }
      success(data);
    },
    settings: {
      horizontal: true,
      minIndex: 0,
      startIndex: 0
    }
  };
  
  goToCategoryListPage(typeOfHomePoint: string ) {
    this._router.navigate([`/${typeOfHomePoint}`]);
  }
}
